import {debounce} from "./debounce";

export const memberSearchTagify = (selector, enableSmartGroups, options) => {

    const input = document.querySelector(selector);

    if (!input) {
        console.warn(`A tagify instance cannot be created because the no element with the selector "${selector}" could be found.`);
        return;
    }

    let whitelist = [];
    if (input.value.length > 0) {
        whitelist = JSON.parse(input.value);
    }

    const defaultOptions = {
        tagTextProp: "text",
        enforceWhitelist: true,
        whitelist: whitelist,
        skipInvalid: true,
        dropdown: {
            closeOnSelect: true,
            enabled: 1,
            classname: "users-list",
            searchKeys: ["text"]
        },
        templates: {
            tag: memberTemplate,
            dropdownItem: memberSuggestionTemplate
        }
    };

    const tagify = new Tagify(input, {...defaultOptions, ...options});

    tagify.on("input", debounce(async (e) => {
        tagify.whitelist = null;
        tagify.loading(true);

        const {data} = await axios.get(`/members?term=${e.detail.value}&smartGroups=${enableSmartGroups}`);
        tagify.whitelist = data.results;
        tagify
            .loading(false)
            .dropdown.show(e.detail.value);
    }, 300));

    return tagify;
}

export const ajaxTagify = (selector, url) => {

    const input = document.querySelector(selector);

    if(!input){
        console.warn(`A tagify instance cannot be created because the no element with the selector "${selector}" could be found.`);
        return;
    }

    let whitelist = [];
    if(input.value.length > 0){
        whitelist = JSON.parse(input.value);
    }

    const tagify = new Tagify(input, {
        tagTextProp: "text",
        whitelist: whitelist,
        enforceWhitelist: true,
        skipInvalid: true,
        dropdown: {
            mapValueTo: "text",
            closeOnSelect: true,
            enabled: 1,
            classname: "tagify-list",
            searchKeys: ["text"]
        },
    });

    tagify.on("input", debounce(async (e) => {
        tagify.whitelist = null;
        tagify.loading(true);

        const {data} = await axios.get(`${url}&term=${e.detail.value}`);
        tagify.whitelist = data.results;
        tagify
            .loading(false)
            .dropdown.show(e.detail.value);
    }, 300));

    return tagify;
};

export const whitelistTagify = (selector, options) => {
    const el = document.querySelector(selector);
    if(!el)
        return;

    const defaultOptions = {
        whitelist: el.dataset.whitelistItems ? JSON.parse(el.dataset.whitelistItems) : "",
        enforceWhitelist: true,
        originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(','),
        dropdown: {
            maxItems: 20,
            enabled: 0,
            classname: "tags-look",
            closeOnSelect: false
        }
    };

    return new Tagify(el, {...defaultOptions, ...options});
}

//#region Templates

function memberTemplate(tagData) {
    return `
        <tag title="${tagData.text}" contenteditable='false' spellcheck='false' tabIndex="-1" class="${this.settings.classNames.tag} py-3" ${this.getAttributes(tagData)}>
            <x title='' class='tagify__tag__removeBtn' role='button' aria-label='remove tag'></x>
            <div class="d-flex align-items-center">
                <span class='tagify__tag-text'>${tagData.text}</span>
            </div>
        </tag>
    `;
}

function memberSuggestionTemplate(tagData) {
    return `
        <div ${this.getAttributes(tagData)} class='tagify__dropdown__item d-flex align-items-center'
            tabindex="0"
            role="option">
            <div class="d-flex flex-column">
                <strong>${tagData.text}</strong>
            </div>
        </div>
    `;
}

//#endregion Templates

